import { SlideMedia } from 'routes/Home/Old/types'
import styled, { keyframes } from 'styled-components'
import { hardcoreAnimationEase, media } from 'utils/style-utils'

const animationIn = keyframes`
  from {
    transform: translateX(-1000px);
  }
`

interface Props {
  shouldLoadLogo: boolean
  active: boolean
  media: SlideMedia
}

export const Logo = styled.div<Props>`
  animation: ${animationIn} 1.3s ${hardcoreAnimationEase};
  ${({ active }: Props) => (!active ? 'animation: none' : '')};

  display: ${({ shouldLoadLogo }) => (shouldLoadLogo ? 'inherit' : 'none')};
  position: absolute;
  z-index: 1;

  width: 100%;
  height: 100%;

  background-image: url(${({ media: { picture } }) => picture.lg.png});
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: center left;

  ${media.md`
    background-size: 75%;
    animation: none;
  `}
`
